<template>
    <div id="release">
        <div style="width: 100%;">
            <Breadcrumb></Breadcrumb>
            <div class="form-body">
                <el-form :ref="form" :model="form" label-width="80px" style="padding: 0 5px;margin-top: 10px;background-color: white;">
                    <el-form-item label="店铺名称:">
                        <el-radio-group v-model="form.name" class="hide_input"  @change="loadData">
                            <el-radio label="all">全部</el-radio>
                            <el-radio v-for="(item,index) in dpList" :label="item.shopId">{{item.shopName}}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <div style="border-top: 1px dashed #afafaf;padding-top: 5px;background-color: white;">
                        <el-form-item label="搜索类型:">
                            <el-radio-group v-model="form.searchType" size="small" class="hide_input"  @change="loadData">
                                <el-radio :label="1">标题</el-radio>
                                <el-radio :label="2">SKU</el-radio>
                                <el-radio :label="3">产品ID</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="搜索内容:" class="sea_cont">
                            <el-input size="small" v-model="form.searchStr" style="width: 50%;border: 0px;" placeholder="请输入内容"></el-input>
                            <el-button size="small" type="primary" @click="search" style="margin-left: 10px">搜索</el-button>
                            <el-link :underline="false" @click="showMoreSearchItem" style="color: #409eff;margin-left: 10px">高级搜索</el-link>
                        </el-form-item>
                    </div>
                    <div class="detailForm" v-show="showMoreItem">
                        <el-form  :model="detailForm" ref="detailForm" label-width="110px" style="padding: 0 5px">

                            <el-form-item size="small" label="站点:" prop="site">
                                <el-select clearable  v-model="detailForm.station" style="width: 93%">
                                    <el-option
                                            v-for="item in dpzdxzList"
                                            :key="item.dictValue"
                                            :label="item.dictLabel"
                                            :value="item.dictCode">
                                    </el-option>
                                </el-select>
                            </el-form-item>



                            <el-form-item size="small" label="产品分类:" prop="goodsType">
                                <el-select clearable  v-model="detailForm.goodsType" style="width: 93%"></el-select>
                            </el-form-item>
                            <el-form-item label="价格:">
                                <div class="double_item" style="display: flex;width: 93%">
                                    <el-col>
                                        <el-form-item prop="price_start">
                                            <el-input v-model="detailForm.price_start" size="small" style="width: 100%"/>
                                        </el-form-item>
                                    </el-col>
                                    -
                                    <el-col>
                                        <el-form-item prop="price_end">
                                            <el-input v-model="detailForm.price_end" size="small" style="width: 100%"/>
                                        </el-form-item>
                                    </el-col>
                                </div>
                            </el-form-item>
                            <el-form-item label="促销价:">
                                <div class="double_item" style="display: flex;width: 93%">
                                    <el-col>
                                        <el-form-item prop="pro_price_start">
                                            <el-input v-model="detailForm.pro_price_start" size="small" style="width: 100%"/>
                                        </el-form-item>
                                    </el-col>
                                    -
                                    <el-col>
                                        <el-form-item prop="pro_price_end">
                                            <el-input v-model="detailForm.pro_price_end" size="small" style="width: 100%"/>
                                        </el-form-item>
                                    </el-col>
                                </div>
                            </el-form-item>
                            <el-form-item label="库存:">
                                <div class="double_item" style="display: flex;width: 93%">
                                    <el-col>
                                        <el-form-item prop="inventory_start">
                                            <el-input v-model="detailForm.inventory_start" size="small" style="width: 100%"/>
                                        </el-form-item>
                                    </el-col>
                                    -
                                    <el-col>
                                        <el-form-item prop="inventory_end">
                                            <el-input v-model="detailForm.inventory_end" size="small" style="width: 100%"/>
                                        </el-form-item>
                                    </el-col>
                                </div>
                            </el-form-item>
                            <el-row>
                                <el-col style="width: 110px">
                                    <el-form-item label-width="0" prop="dateType">
                                        <el-select clearable  v-model="detailForm.dateType" size="small" style="width: 95%" placeholder="请选择">
                                            <el-option label="更新时间" value="update"></el-option>
                                            <el-option label="创建时间" value="create"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col style="width:calc(100% - 110px)">
                                    <el-form-item label-width="0" prop="dateValue">
                                        <el-date-picker
                                                size="small"
                                                style="width: 93%"
                                                v-model="detailForm.dateValue"
                                                type="daterange"
                                                align="right"
                                                unlink-panels
                                                range-separator="至"
                                                start-placeholder="开始日期"
                                                end-placeholder="结束日期"
                                                :picker-options="pickerOptions">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-form-item>
                                <div style="text-align: right;padding-right: 10px">
                                    <el-link :underline="false" style="color: #409eff;margin-left: 10px" @click="cancle_1">取消</el-link>
                                    <el-link :underline="false" style="color: #409eff;margin: 0 10px" @click="resetForm">重置</el-link>
                                    <el-button size="small" type="primary">搜索</el-button>
                                </div>
                            </el-form-item>
                        </el-form>
                    </div>
                </el-form>
            </div>
        </div>

        <div>
            <el-table id="outTable" ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange"
                      :span-method="arraySpanMethod">
                <el-table-column type="selection" width="40" align="center"></el-table-column>

                <el-table-column prop="mainPic" label="图片" width="95" align="center">
                    <template scope="scope">
                        <el-popover placement="right" width="300" trigger="hover" :close-delay="closeDelay">
                            <div style="text-align: right;background-color: rgba(239,239,239,1);height: 25px;line-height: 25px">
                                <span style="padding-right: 20px;cursor: pointer;color: #409eff" @click="searchProductSource(scope.row)">添加来源</span>
                            </div>
                            <img  class="img-big" :src="scope.row.mainPic" style="width: 300px;height: 300px"/>
                            <img slot="reference" class="img-small" :src="scope.row.mainPic"/>
                            <div slot="reference" style="font-size: 12px">来源：<a style="text-decoration: none;color: #409eff" :href="scope.row.dataUrl" target="_blank">{{foramtDataSource(scope.row.dataSource)}}</a></div>
                        </el-popover>

                    </template>
                </el-table-column>

                <!--<el-table-column prop="proTitle" label="标题/产品ID" width="200"></el-table-column>-->
                <el-table-column prop="proTitle" label="标题/产品ID" width="300">
                    <template slot-scope="scope">
                        <el-row style="text-align: center">{{scope.row.proTitle}}</el-row>
                        <div style="padding-left: 20px;margin-top: 20px">
                            <el-row style="color: #8a8a8a">店铺[{{scope.row.shopName}}]</el-row>
                            <el-row>备注:{{scope.row.remark}}</el-row>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column prop="htmlCode"  label="SKU" align="center">
                    <template slot-scope="scope">
                        <div v-html="scope.row.htmlCode"></div>
                    </template>
                </el-table-column>
                <el-table-column label="价格" align="center"></el-table-column>
                <el-table-column label="促销价" align="center"></el-table-column>
                <el-table-column label="库存" align="center"></el-table-column>
                <el-table-column prop="createTime" label="时间" align="center" width="200">
                    <template slot-scope="scope">
                        <el-row>创建:</el-row>
                        <el-row>{{scope.row.createTime}}</el-row>
                        <el-row>更新:</el-row>
                        <el-row>{{scope.row.updateTime}}</el-row>
                    </template>
                </el-table-column>

                <el-table-column prop="handel" label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button  type="text" size="mini" @click="addRemark(scope.row)">添加备注</el-button><br/>
                    </template>
                </el-table-column>
                <el-table-column prop="id" label="ID" v-if="false"></el-table-column>
            </el-table>
            <!-- <el-pagination background style="float: right;" @size-change="handleSizeChange" @current-change="handleCurrentChange"
                            :current-page="currentPage" :page-sizes="[100, 200, 300, 400]" :page-size="100" layout="total, sizes, prev, pager, next, jumper"
                            :total="400">
             </el-pagination>-->
            <pagination
                    v-show="total>0"
                    :total="total"
                    :page.sync="form.pageNum"
                    :limit.sync="form.pageSize"
                    @pagination="loadData"
            />
        </div>
        <!--添加备注-->
        <el-dialog :close-on-click-modal="false"   title="添加备注" width="35%" :visible.sync="noteDialogVisible" class="note-dialog">
            <el-row style="display: flex;align-items: center">
                <el-col :span="2">
                    <p>内容:</p>
                </el-col>
                <el-col :span="22">
                    <el-input v-model="noteContent"  placeholder="请输入介绍信息" type="textarea" :rows="10">

                    </el-input>
                </el-col>
            </el-row>
            <div slot="footer" class="dialog-footer">
                <el-button @click="noteDialogVisible = false" size="small">取 消</el-button>
                <el-button type="primary" @click="submitRemark" size="small">确 定</el-button>
            </div>
        </el-dialog>

        <!--添加来源-->
        <el-dialog :close-on-click-modal="false"   title="添加来源" width="35%" :visible.sync="sourceDialogVisible" >
            <el-row style="display: flex;align-items: center">
                <el-row>
                    <el-col :span="1">
                        <div style="font-size: 20px;background-color: #F7F7F7;text-align: center">1</div>
                    </el-col>
                    <el-input v-model="DefaultUrl" placeholder="请输入内容"
                              style="width: 400px;margin-right: 20px" size="small"></el-input>
                    <el-button type="primary" size="small" @click="goUrl">访问</el-button>
                    <el-button icon="el-icon-plus" @click="addUrl" size="small"></el-button>
                </el-row>
            </el-row>
            <div slot="footer" class="dialog-footer">
                <el-button @click="sourceDialogVisible = false" size="small">取 消</el-button>
                <el-button type="primary" @click="submitSource" size="small">确 定</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script type="text/ecmascript-6">
    import Breadcrumb from '@/components/common/Breadcrumb'
    import {getDpList,getInnerDataList,moveToReady,publishToOnline,bathMoveToReady,updateLazadaRemark,singledelete,batchdelete,getTreeList,batchMoveCatalog,batchPublishItem,loadZdxz} from '@/api/product/lazada'
    import {handleTree} from '@/utils/jn'
    import store from '../../../store'
    export default {
        name: "TimeInterval",
        components:{Breadcrumb},
        data() {
            return {
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                closeDelay:0,
                // 总条数
                total: 0,
                currentPage: 1,
                noteContent:'',
                classManageDialog:false,//管理分类弹窗默认关闭
                form: {
                    pubStatus:'03',//发布中
                    name:'all',
                    searchStr: null,
                    searchType: 1,
                    pageNum:1,
                    pageSize:10,
                    remark:'',
                    typeNo:''
                },
                detailForm:{
                    station:null,
                    goodsType:null,
                    price_start:null,
                    price_end:null,
                    pro_price_start:null,
                    pro_price_end:null,
                    inventory_start:null,
                    inventory_end:null,
                    dateValue:'',
                    dateType:'update'
                },
                showMoreItem:false,
                dpList: [],
                dpzdxzList:[],
                tableData: [],
                spanArr: [],
                innerTableData:[],
                innerData: [],
                props: {
                    id: 'id',
                    children: 'children',
                    label: 'typeNme'
                },
                treeData: [],
                count:1,
                noteDialogVisible:false,//备注弹框
                sourceDialogVisible:false,//备注弹框
                DefaultUrl:'',
                ids:[], //选中的ID
                lazadaList:[], //批量对象
                lazadaList2:[], //批量对象
                updateStatePara:{},//批量移动分类
                updateStateParaForpub:{},//批量发布
            }
        },
        computed:{
            typeNo(){
                return this.$route.query.id;
            }
        },
        watch:{
            typeNo(){
                this.loadData();
            }
        },
        created() {
            var that = this;
            getDpList().then(function(res){
                that.dpList =  res.data;
            }).catch(function(error){

            });
            this.loadData();
            //获取站点
            this.getZdxz();

        },
        methods: {
            searchProductSource(){
                this.sourceDialogVisible=true;
            },

            addUrl:function(){

            },
            goUrl:function(){
                window.open(this.form.DefaultUrl, '_blank').location;
            },
            submitSource:function(){
                alert("保存成功");
            },

            getZdxz: function() {
                this.loading = true;
                /*loadZdxz().then((res) => {
                    this.dpzdxzList = res.rows;
                    this.loading = false;
                })*/
                let that =this;
                that.getDicts("lazada_station").then(response => {
                    that.dpzdxzList = response.data;
                });
            },
            editRow: function(row) {
                this.$router.push({path:"/product/lazada/edit",query:{pId:row.pId}})
            },
            publishRow: function(row) {
                this.$confirm('确定要发布该产品吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function() {
                    let param ={'pId':row.pId};
                    return publishToOnline(param);
                }).then((res) => {
                    if(res.code == 200){
                        this.msgSuccess("产品发布成功");
                        this.loadData();
                    }
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
            foramtDataSource(val){
                if(val == '01'){
                    return "1688";
                }else if(val == '02'){
                    return "速卖通";
                }else if(val == '03'){
                    return "Lazada";
                } else if(val == '04'){
                    return "Amazon";
                } else if(val == '05'){
                    return "Shopee";
                }else if(val == '06'){
                    return "淘宝"
                }else if(val == "07"){
                    return "京东"
                }
                return "未知";
            },
            deleteRow:function(row) {
                var pId = row.pId;
                this.$confirm('是否确认删除Lazada产品标题为'+row.proTitle+'的数据项?', "警告", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(function() {
                    return singledelete(pId);
                }).then(() => {
                    this.loadData();
                    this.msgSuccess("删除成功");
                }).catch(function() {

                });
            },

            handleNodeClick(data,Node) {
                // 如果是顶级父节点
                if (Node.parent.level === 0) {
                    // 不会触发事件
                } else if (data.isPar!=1) {
                    this.batchMoveCatalog(data);
                }
            },

            loadNode(node, resolve) {
                var that =this;
                if (node.level === 0) {
                    //查询顶级节点
                    let params = {};
                    getTreeList(params).then(function(res){
                        that.treeData = that.createTreeData(res.data);
                        return resolve(that.treeData);
                    }).catch(function(error){
                        this.$message.error(res.msg);
                    });
                }else {
                    let params = {pTypeNo:node.data.id};
                    // 根据父节点id找寻下一级的所有节点
                    getTreeList(params).then(res => {
                        return resolve(res.data);
                    });
                }

            },

            createTreeData(data){
                let treedata = data.filter(father =>{
                    if(father['pTypeNo'] == ""||father['pTypeNo'] == null){
                        father['pTypeNo'] = '0'
                    }
                    let childArr = data.filter(child =>{
                        return  child['pTypeNo'] == father.id;
                    });
                    childArr.length > 0?father.children =childArr:'';
                    return father['pTypeNo'] == '0';
                });
                return treedata ;
            },

            loadData(){
                this.updateCurrentTime();
                var that =this;
                this.loading = true;
                that.form.typeNo =this.typeNo;
                getInnerDataList(this.form).then(function(res){
                    that.tableData =  res.rows;
                    that.total = res.total;
                    /*store.dispatch("setReleaseNum",res.total);*/
                    that.loading = false;
                    for (let key in that.tableData) {
                        //SKU集合赋值
                        let innerData = that.tableData[key].lazadaSkus;
                        that.innerData= innerData;
                        that.Generationhtml(key);
                    }
                }).catch(function(error){

                });
            },
            //生成表格HTML
            Generationhtml(key){
                // 控制单独的class
                var className = key;
                var tabHtml ='<table class="innerTab" style="width: 100%">'
                this.innerData.forEach((item,index)=>{
                    //转空字符
                    if (item.skuno==null){
                        item.skuno='';
                    }
                    if (item.price==null){
                        item.price='';
                    }
                    if (item.promPrice==null){
                        item.promPrice='';
                    }
                    if (item.invent==null){
                        item.invent='';
                    }
                    if(index < 5){
                        tabHtml += `<tr>
					<td >`+item.skuno +`</td>
					<td >`+item.price +`</td>
					<td >`+item.promPrice +`</td>
					<td >`+item.invent +`</td>

				</tr>`;
                    }else{
                        tabHtml += `<tr  style="display: none" class=${className}>
					<td >`+item.skuno +`</td>
					<td >`+item.price +`</td>
					<td >`+item.promPrice +`</td>
					<td >`+item.invent +`</td>
				</tr>`;
                    }

                });
                if(this.innerData.length > 5){
                    tabHtml += `</table><el-row class="tab_butt"><div id="row_bt" onclick="explanRow(${className})">展开<i class="el-icon-caret-bottom"></i></div></el-row>`;
                }else{
                    tabHtml += `</table>`;
                }
                this.tableData[key].htmlCode = tabHtml;
                window.explanRow = function (val) {
                    var flag = $("."+val).is(":hidden");
                    if(flag){
                        $("#row_bt").html(`收起<i class="el-icon-caret-top"></i>`);
                        $("."+val).show();
                    }else{
                        $("#row_bt").html(`展开<i class="el-icon-caret-bottom"></i>`);
                        $("."+val).hide();
                    }
                }
            },


            setClassManage:function(){
                this.classManageDialog = true;
            },
            closeCMDialog_f:function(){
                this.classManageDialog = false;
            },
            show: function() {

            },
            search: function() {
                this.loadData();
            },
            batchHandle: function(val) {
                if ("1" == val) {
                    this.batchPublish();
                } else if("2" == val){
                    //todo批量定时发布
                }else{
                    this.batchDelete();
                }
            },
            //批量发布
            batchPublish() {
                let that =this;
                console.log(that.lazadaList2);
                if (that.lazadaList2.length=='0'){
                    this.msgError("至少选择一条数据!");
                    return;
                }
                this.$confirm('是否选中发布' + this.ids.length + '条数据项?', "警告", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(function() {
                    return batchPublishItem(that.lazadaList2);
                }).then(() => {
                    this.loadData();
                    this.msgSuccess("批量发布成功");
                }).catch(function() {});
            },

            //批量删除
            batchDelete() {
                let that =this;
                const ids =this.ids;
                console.log(that.lazadaList);
                if (that.lazadaList.length=='0'){
                    this.msgError("至少选择一条数据!");
                    return;
                }
                this.$confirm('是否删除选中的' + this.ids.length + '条数据项?', "警告", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(function() {
                    return batchdelete(ids);
                }).then(() => {
                    this.loadData();
                    this.msgSuccess("删除成功");
                }).catch(function() {});
            },
            //用户勾选
            handleSelectionChange(val) {
                var that = this;
                that.ids=[];
                that.lazadaList=[];
                that.lazadaList2=[];
                //获取当前用户
                var userName = this.$store.state.user.name;
                val.forEach((item) => {
                    //批量移动分类
                    this.updateStatePara={
                        "pId":item.pId,
                        "operNo":userName,
                        "pubStatus":'03',
                        "typeNo":""
                    };
                    this.ids.push(item.pId);
                    this.lazadaList.push(this.updateStatePara);
                });

                val.forEach((item) => {
                    //批量发布
                    this.updateStateParaForpub={
                        "pId":item.pId,
                        "operNo":userName,
                        "pubStatus":'03'
                    };
                    this.lazadaList2.push(this.updateStateParaForpub);
                });


            },
            //合并列
            arraySpanMethod: function({row,column,rowIndex,columnIndex}) {
                if (columnIndex === 3) {
                    return [1, 4];
                }else if(columnIndex === 4 || columnIndex === 5 ||columnIndex === 6){
                    //将合并后的第四、五、六列单元格清除掉，不然后面的单元格会后移
                    return [0, 0];
                }
            },
            getSpanArr(data) {
                for (var i = 0; i < data.length; i++) {
                    if (i === 0) {
                        this.spanArr.push(1);
                        this.pos = 0
                    } else {
                        // 判断当前元素与上一个元素是否相同,因合并第一个所以[0]
                        if (data[i]["id"] === data[i - 1]["id"]) {
                            this.spanArr[this.pos] += 1;
                            this.spanArr.push(0);
                        } else {
                            this.spanArr.push(1);
                            this.pos = i;
                        }
                    }
                }
            },
            handleSizeChange: function(val) {
                console.log(`每页: ${val}条`);
            },
            handleCurrentChange(val) {
                console.log(`当前页: ${val}`);
            },
            move: function() {
                this.$confirm('确定要 [移入到待发布吗]?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$message({
                        type: 'success',
                        message: '移入成功!'
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消移入'
                    });
                });
            },
            cancelTime: function() {
                this.$confirm('确定要 [取消发布吗]?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$message({
                        type: 'success',
                        message: '取消成功!'
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消失败'
                    });
                });
            },

            showMoreSearchItem:function(){
                this.showMoreItem = !this.showMoreItem;
            },
            cancle_1:function(){
                this.showMoreItem = false;
            },
            resetForm:function(){
                this.$refs['detailForm'].resetFields()
            },
            //添加备注方法
            addRemark:function(row){
                var that =this;
                /*for (let key in that.form) {
                 that.form[key]=null;
                 }*/
                that.noteDialogVisible=true;
                that.form.remark =row.remark;
                that.noteContent =row.remark;
                that.form.pId=row.pId;
            },
            //提交备注
            submitRemark(remark){
                this.form.remark =this.noteContent;
                updateLazadaRemark(this.form).then((res) => {
                    if (res.code === 200) {
                        this.msgSuccess("添加成功");
                        this.loadData();
                        this.noteDialogVisible = false;
                    }
                })
            },


            batchMoveCatalog: function(data) {
                let that =this;
                if (that.lazadaList.length=='0'){
                    this.msgError("至少选择一条数据!");
                    return;
                }else if(data.isPar=='1') {
                    this.msgError("该节点不支持分类!");
                    return;
                }

                that.lazadaList.forEach((item) => {
                    item.typeNo=data.typeNo;
                });

                console.log(that.lazadaList);
                this.$confirm('确定要将选中的商品移入到该类别吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function() {
                    return batchMoveCatalog(JSON.stringify(that.lazadaList));
                }).then(() => {
                    this.$message({
                        type: 'success',
                        message: '移入成功!'
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
            //修改stroe中的currentTime
            updateCurrentTime(){
                store.dispatch('setCurrentTime',new Date())
            }

        },
        mounted() {
            this.getSpanArr(this.tableData);
            // jQuery(".tab_butt").click(function () {
            //     alert(123456);
            // });
        }
    }
</script>

<style scoped>
    @import '../../../assets/css/Shopee.css';
    @import '../../../assets/css/product.css';
    #ready-release{
        width: 100%;
    }
    .detailForm{
        padding-top: 5px;
        margin-left: 85px;
        width: 50%;
        height: auto;
        margin-bottom: 8px;
    }
    .detailForm .el-form-item,.sea_cont{
        margin-bottom: 10px !important;
    }
    .double_item .el-form-item{
        margin-bottom: 0px !important;
    }
</style>
